import $ from 'jquery';

document.addEventListener("turbo:load", function(event) {
  // Paginate font page rounds index with Load More
  if ($("#loadMoreRounds").length) {
    var pageCount = $("#loadMoreRounds").attr("data-page-count");
    if (pageCount) {
      pageCount = parseInt(pageCount);
    } else {
      pageCount = 1;
    }

    $("#loadMoreRounds").click(function(e) {
      e.preventDefault();
      // Load more button hidden, shown again on partial if not last paage
      $("#loadMoreRounds").hide();
      $("#showLoader").css("display", "block");
      pageCount = parseInt($("#loadMoreRounds").attr("data-page-count"));
      pageCount += 1;

      $.ajax({
        type: "GET",
        url: $(this).attr("href"),
        data: {
          page: pageCount,
        },
        dataType: "script",
        success: function() {
          $("#showLoader").css("display", "none");
        },
      });
    });
  }
});
